import styled, { createGlobalStyle } from 'styled-components/macro'
import { Container } from 'components/container'
import { mq } from 'styles/mq'
import { styleReset } from 'styles/misc'

export const GlobalSnap = createGlobalStyle`
  body {
    scroll-snap-type: y proximity;
  }
`

export const PageContent = styled(Container)`
  ${mq.ltLarge} {
    &,
    > div {
      display: contents;
    }
  }

  ${mq.large} {
    display: grid;
    grid-template-columns: 48rem 1fr;
  }
`

export const Main = styled.main`
  ${mq.large} {
    max-width: 72rem;
  }
`

export const Nav = styled.nav`
  ${mq.large} {
    padding-right: 3rem;
    margin-right: 9rem;
    border-right: 1px solid #626262;
  }
`

export const BottomSpacing = styled.div`
  ${mq.ltLarge} {
    height: 5rem;
  }
`
export const ScrollToTop = styled.button`
  --size: 6rem;

  ${styleReset}
  display: block;
  position: sticky;
  width: var(--size);
  height: var(--size);
  bottom: 0;
  left: 100%;
  box-shadow: 0 -1px 10px #1a394829;
  border-top-left-radius: 2rem;
  transition: opacity 0.3s;
  background: rgba(255 255 255 / 0.95)
    url("data:image/svg+xml,%3Csvg width='19' height='22' viewBox='0 0 19 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.2522 20.2157C8.2522 20.906 8.81184 21.4657 9.5022 21.4657C10.1926 21.4657 10.7522 20.906 10.7522 20.2157L8.2522 20.2157ZM10.3861 0.478693C9.89792 -0.00946237 9.10647 -0.00946043 8.61831 0.478695L0.663363 8.43365C0.175208 8.9218 0.175208 9.71326 0.663363 10.2014C1.15152 10.6896 1.94298 10.6896 2.43113 10.2014L9.5022 3.13034L16.5733 10.2014C17.0614 10.6896 17.8529 10.6896 18.341 10.2014C18.8292 9.71326 18.8292 8.9218 18.341 8.43364L10.3861 0.478693ZM10.7522 20.2157L10.7522 1.36258L8.2522 1.36258L8.2522 20.2157L10.7522 20.2157Z' fill='%231A3948'/%3E%3C/svg%3E%0A")
    center center no-repeat;
  z-index: 2;
  ${mq.medium} {
    display: none;
  }
`
